module.exports = __webpack_public_path__ + "static/media/trash-grey.6eb9d488.svg";